export default "__VITE_ASSET__gvNAarxq__"